export enum EditUserFormValuesNames {
  USERNAME = 'username',
  ROLES = 'roles',
  CLIENT = 'client',
}

export interface EditUserFormValues {
  [EditUserFormValuesNames.USERNAME]: string;
  [EditUserFormValuesNames.ROLES]: Record<string, string>[];
  [EditUserFormValuesNames.CLIENT]: Record<string, string>;
}
